import { Component, OnInit } from "@angular/core";
import {MatDialogRef} from "@angular/material/dialog";
import {SettingService} from "../../services/setting.service";
import {environment} from "../../../../environments/environment";
import {SOCURE_VERIFY_LINK_KEY} from "../../constants";

@Component({
  selector: "socure-loading-dialog",
  templateUrl: "./socure-dialog.component.html",
  styleUrls: ["./socure-dialog.component.scss"]
})
export class SocureDialogComponent {

  userRequestedClose: boolean = false;
  referenceId : string | undefined = "";
  verifyLink : string = "";

  constructor(public dialogRef: MatDialogRef<SocureDialogComponent>, public settingService : SettingService) {

  }

  ngOnInit(): void {
    this.settingService.getGlobalSettings(environment.app_settings_version).then(globalSetting => {
      globalSetting.forEach(globalSetting => {
        if(globalSetting.name === SOCURE_VERIFY_LINK_KEY) this.verifyLink = globalSetting.value!;
      });
    });
  }
}
